module.exports = __webpack_public_path__ + "static/media/51.1b5f0a3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/51.jpg
// module id = 995
// module chunks = 0